import { Accordion, Button, Card, Modal } from "react-bootstrap";
import CustomAccordionToggle from "../common/CustomAccordionToggle";
import { useAccordionState } from "../../hooks/useAccordionState";

const PlateauModal = ({ show, handleClose }) => {
  const { openItems, manageOpenItems } = useAccordionState(["3"]);

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title className="h5">3D都市モデルの表示について</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p></p>
        <Accordion activeKey={openItems}>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="0" onClick={manageOpenItems}>
                概要
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <p>
                  3D都市モデルの表示機能は、
                  <a
                    href="https://www.aigid.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    一般社団法人社会基盤情報流通推進協議会（AIGID）
                  </a>
                  の支援を受け、国土交通省
                  <a
                    href="https://www.mlit.go.jp/plateau/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Project PLATEAU
                  </a>
                  の3D都市モデル（建築物、地形）を表示する機能を開発し、不動産分野における利活用の実証実験を行ったものです。
                </p>
                <div className="d-flex mb-3">
                  <div>国土交通省報道発表資料（令和6年9月6日）：</div>
                  <div>
                    <a
                      href="https://www.mlit.go.jp/report/press/toshi03_hh_000141.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      不動産分野においてPLATEAUの社会実装を進めます！
                      <br />
                      ～3D都市モデルを活用したビジネス・ソリューションを選定～
                    </a>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="1" onClick={manageOpenItems}>
                {" "}
                PLATEAU（プラトー）とは
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <div className="d-flex">
                  <div className="text-center w-50">
                    <img src="mapple01/mojmap/plateau.png" alt="" />
                  </div>
                  <div className="w-50">
                    <p>
                      都市デジタルツインの実現を目指し、国土交通省が推進するプロジェクトです。様々な分野におけるソリューション開発やコミュニティ育成、技術開発等がおこなわれています。
                    </p>
                    <p>
                      ［Project PLATEAU］ウェブサイト：
                      <a
                        href="https://www.mlit.go.jp/plateau/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://www.mlit.go.jp/plateau/
                      </a>
                    </p>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="2" onClick={manageOpenItems}>
                3D都市モデル(Project PLATEAU)を表示可能な都市
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <div className="d-flex my-3">
                  <div>
                    <nobr>北海道　</nobr>
                  </div>
                  <div>
                    <a href="#17/43.0620109700327/141.354173703728">札幌市</a>　
                    <a href="#17/42.3151888901822/140.973796426389">室蘭市</a>　
                    <a href="#17/42.6503372266856/143.187791901014">更別村</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>青森県　</nobr>
                  </div>
                  <div>
                    <a href="#17/41.2928176765337/141.183372919709">むつ市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>岩手県　</nobr>
                  </div>
                  <div>
                    <a href="#17/39.7019559326907/141.154380189141">盛岡市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>宮城県　</nobr>
                  </div>
                  <div>
                    <a href="#17/38.2680534907665/140.869439606757">仙台市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>福島県　</nobr>
                  </div>
                  <div>
                    <a href="#17/37.4004470581204/140.35970408443">郡山市</a>　
                    <a href="#17/37.0504502348213/140.887696130279">いわき市</a>
                    　<a href="#17/37.126344190899/140.210961752703">白河市</a>
                    　<a href="#17/37.7973419464559/140.918910515319">相馬市</a>
                    　
                    <a href="#17/37.642305102735/140.957264391264">南相馬市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>茨城県　</nobr>
                  </div>
                  <div>
                    <a href="#17/36.0834661238463/140.076487751712">つくば市</a>
                    　<a href="#17/36.1586669938795/140.516456454952">鉾田市</a>
                    　<a href="#17/36.1082031324177/139.795023118809">境町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>栃木県　</nobr>
                  </div>
                  <div>
                    <a href="#17/36.5551871143144/139.882579041161">宇都宮市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>群馬県　</nobr>
                  </div>
                  <div>
                    <a href="#17/36.3895249342169/139.063449814695">前橋市</a>　
                    <a href="#17/36.4057400203083/139.330804024756">桐生市</a>　
                    <a href="#17/36.2448451322002/139.542095252944">館林市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>埼玉県　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.8614717700204/139.645499690082">
                      さいたま市
                    </a>
                    　<a href="#17/36.1472405660145/139.388787933997">熊谷市</a>
                    　<a href="#17/36.1314214070912/139.601780755184">加須市</a>
                    　
                    <a href="#17/35.9741125193552/139.754932242665">春日部市</a>
                    　<a href="#17/35.891084122611/139.790903916285">越谷市</a>
                    　<a href="#17/35.8175943136509/139.677903232167">戸田市</a>
                    　<a href="#17/35.7930799801226/139.565701716115">新座市</a>
                    　<a href="#17/36.0622383887224/139.666878424725">久喜市</a>
                    　<a href="#17/35.8221499353868/139.83950893016">八潮市</a>
                    　<a href="#17/35.9943205471748/139.662145209993">蓮田市</a>
                    　<a href="#17/35.8959674618592/139.85565799853">吉川市</a>
                    　<a href="#17/36.0191234750899/139.676918536217">白岡市</a>
                    　
                    <a href="#17/35.9415141342279/139.316006630597">毛呂山町</a>
                    　<a href="#17/36.0226853053668/139.722858110459">宮代町</a>
                    　<a href="#17/36.0257608506313/139.736694912282">杉戸町</a>
                    　<a href="#17/35.9256642412671/139.815223518141">松伏町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>千葉県　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.4284172653302/140.288065377254">茂原市</a>　
                    <a href="#17/35.8674691610211/139.97604695284">柏市</a>　
                    <a href="#17/35.7226211446353/140.09977256288">八千代市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>東京都　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.6940586073774/139.753651291665">千代田区</a>
                    　<a href="#17/35.6705956210378/139.772113948164">中央区</a>
                    　<a href="#17/35.658056016554/139.751511497801">港区</a>　
                    <a href="#17/35.6939951347146/139.703410887201">新宿区</a>　
                    <a href="#17/35.7080320037103/139.752225321206">文京区</a>　
                    <a href="#17/35.712606882892/139.779983879507">台東区</a>　
                    <a href="#17/35.7107117833334/139.801346289987">墨田区</a>　
                    <a href="#17/35.6728932225762/139.817332771087">江東区</a>　
                    <a href="#17/35.6092776307969/139.730170473033">品川区</a>　
                    <a href="#17/35.6414555471601/139.698258636757">目黒区</a>　
                    <a href="#17/35.5613817485319/139.716108922841">大田区</a>　
                    <a href="#17/35.6459743240428/139.653119697788">世田谷区</a>
                    　<a href="#17/35.6637871146312/139.697913431684">渋谷区</a>
                    　<a href="#17/35.7089046504129/139.662927938834">中野区</a>
                    　<a href="#17/35.699703915315/139.636273649288">杉並区</a>
                    　<a href="#17/35.7258796562035/139.716655174341">豊島区</a>
                    　<a href="#17/35.7528395604488/139.73333020869">北区</a>　
                    <a href="#17/35.7362331593015/139.783319905864">荒川区</a>　
                    <a href="#17/35.7510232950299/139.709065951366">板橋区</a>　
                    <a href="#17/35.7356727079672/139.651750046646">練馬区</a>　
                    <a href="#17/35.7747930215058/139.804568493752">足立区</a>　
                    <a href="#17/35.7433435034866/139.847341921085">葛飾区</a>　
                    <a href="#17/35.7069388547606/139.868258484726">江戸川区</a>
                    　
                    <a href="#17/35.6664840191931/139.315992621575">八王子市</a>
                    　<a href="#17/35.7139634090195/139.407953754905">立川市</a>
                    　
                    <a href="#17/35.7177375784088/139.565945277626">武蔵野市</a>
                    　<a href="#17/35.6833124547669/139.559744426158">三鷹市</a>
                    　<a href="#17/35.7878470335704/139.275765400608">青梅市</a>
                    　<a href="#17/35.6694139106546/139.477614454513">府中市</a>
                    　<a href="#17/35.705778266121/139.353619851707">昭島市</a>
                    　<a href="#17/35.6506173916523/139.540658911902">調布市</a>
                    　<a href="#17/35.5468495884968/139.438709589676">町田市</a>
                    　
                    <a href="#17/35.6994997236188/139.502916913762">小金井市</a>
                    　<a href="#17/35.7285913233901/139.477542107975">小平市</a>
                    　<a href="#17/35.6712771738264/139.395191883213">日野市</a>
                    　
                    <a href="#17/35.7546189383465/139.468493014916">東村山市</a>
                    　
                    <a href="#17/35.6967039165333/139.469712655183">国分寺市</a>
                    　<a href="#17/35.6838974385179/139.441407790266">国立市</a>
                    　<a href="#17/35.7387590449563/139.326739867815">福生市</a>
                    　<a href="#17/35.6348764189251/139.578727999212">狛江市</a>
                    　
                    <a href="#17/35.7453597301114/139.426537385217">東大和市</a>
                    　<a href="#17/35.7853053582905/139.526794605197">清瀬市</a>
                    　
                    <a href="#17/35.7579561885786/139.52977065396">
                      東久留米市
                    </a>
                    　
                    <a href="#17/35.7548814763084/139.387530823684">
                      武蔵村山市
                    </a>
                    　<a href="#17/35.6370515091576/139.446339934839">多摩市</a>
                    　<a href="#17/35.637937341362/139.504664202687">稲城市</a>
                    　<a href="#17/35.7672167029758/139.310930864462">羽村市</a>
                    　
                    <a href="#17/35.7288716258836/139.294065481992">
                      あきる野市
                    </a>
                    　
                    <a href="#17/35.7257470837019/139.538377562868">西東京市</a>
                    　<a href="#17/35.7719213782751/139.354094554671">瑞穂町</a>
                    　
                    <a href="#17/35.7420980535898/139.257412753773">日の出町</a>
                    　<a href="#17/35.7267936779201/139.148901975661">檜原村</a>
                    　
                    <a href="#17/35.809403160156/139.096084108232">奥多摩町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>神奈川県　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.4505731637698/139.634306903183">横浜市</a>　
                    <a href="#17/35.5307880260922/139.703063917618">川崎市</a>　
                    <a href="#17/35.5713889047193/139.373307692663">相模原市</a>
                    　
                    <a href="#17/35.2814559819184/139.672126570266">横須賀市</a>
                    　<a href="#17/35.4430920573895/139.362489560602">厚木市</a>
                    　<a href="#17/35.2323590401277/139.106968678519">箱根町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>新潟県　</nobr>
                  </div>
                  <div>
                    <a href="#17/37.9161255193194/139.036504517635">新潟市</a>　
                    <a href="#17/37.4466961264313/138.851571675665">長岡市</a>　
                    <a href="#17/37.6663177941515/139.040254969737">加茂市</a>　
                    <a href="#17/37.1478706483629/138.236110580411">上越市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>石川県　</nobr>
                  </div>
                  <div>
                    <a href="#17/36.5611065687705/136.656368788311">金沢市</a>　
                    <a href="#17/36.3026784985935/136.314855359652">加賀市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>山梨県　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.6620371098824/138.568334981725">甲府市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>長野県　</nobr>
                  </div>
                  <div>
                    <a href="#17/36.238051692768/137.972005594472">松本市</a>　
                    <a href="#17/36.0670007642876/138.049344660155">岡谷市</a>　
                    <a href="#17/36.0391718051091/138.113989812312">諏訪市</a>　
                    <a href="#17/35.8274758157599/137.954055947097">伊那市</a>　
                    <a href="#17/35.9955391658312/138.158883975535">茅野市</a>　
                    <a href="#17/36.2488352732351/138.476936065379">佐久市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>岐阜県　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.426199259032/136.759949276939">岐阜市</a>　
                    <a href="#17/35.4402223498587/137.015701188938">
                      美濃加茂市
                    </a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>静岡県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.9751964389013/138.383349977702">静岡市</a>　
                    <a href="#17/34.7107798700811/137.72608742896">浜松市</a>　
                    <a href="#17/35.0956175149282/138.863451449846">沼津市</a>　
                    <a href="#17/35.0963160313233/139.07174712048">熱海市</a>　
                    <a href="#17/35.1184808925592/138.918488874752">三島市</a>　
                    <a href="#17/35.2219949515597/138.621540788326">富士宮市</a>
                    　<a href="#17/34.9655373351235/139.101978448451">伊東市</a>
                    　<a href="#17/34.8361401774894/138.176941985088">島田市</a>
                    　<a href="#17/35.1614040206648/138.676225890292">富士市</a>
                    　<a href="#17/34.7178870017467/137.851542540843">磐田市</a>
                    　<a href="#17/34.8671766061917/138.322923005482">焼津市</a>
                    　<a href="#17/34.7685908065406/137.998346468475">掛川市</a>
                    　<a href="#17/34.8673699686495/138.257571930003">藤枝市</a>
                    　
                    <a href="#17/35.3086149366162/138.93481729852">御殿場市</a>
                    　<a href="#17/34.7501855980755/137.92473017786">袋井市</a>
                    　<a href="#17/34.6795534685342/138.945235936365">下田市</a>
                    　<a href="#17/35.173901555833/138.90675935402">裾野市</a>　
                    <a href="#17/34.7184759337793/137.53163487678">湖西市</a>　
                    <a href="#17/34.9765739594419/138.946707411302">伊豆市</a>　
                    <a href="#17/34.638053869293/138.128067513583">御前崎市</a>
                    　<a href="#17/34.7579007246559/138.084367090093">菊川市</a>
                    　
                    <a href="#17/35.0277151274249/138.928940987123">
                      伊豆の国市
                    </a>
                    　
                    <a href="#17/34.7401488812593/138.224554499967">牧之原市</a>
                    　
                    <a href="#17/34.7727823570004/139.041245632689">東伊豆町</a>
                    　<a href="#17/34.7570138401684/138.987672255755">河津町</a>
                    　
                    <a href="#17/34.6512116158503/138.858199924419">南伊豆町</a>
                    　<a href="#17/34.7528690346781/138.778685082346">松崎町</a>
                    　
                    <a href="#17/34.7716092618417/138.775334573561">西伊豆町</a>
                    　<a href="#17/35.0890099315729/138.953355972645">函南町</a>
                    　<a href="#17/35.0989524258226/138.902793538913">清水町</a>
                    　<a href="#17/35.1376819248456/138.897213086642">長泉町</a>
                    　<a href="#17/35.3600739691189/138.987828437177">小山町</a>
                    　<a href="#17/34.7706916331701/138.251239646304">吉田町</a>
                    　
                    <a href="#17/35.0468349941253/138.081653041741">川根本町</a>
                    　<a href="#17/34.8356550778794/137.92713834846">森町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>愛知県　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.181449198115/136.906360261552">名古屋市</a>
                    　<a href="#17/34.7691881993241/137.391429073258">豊橋市</a>
                    　<a href="#17/34.954940907479/137.172909680382">岡崎市</a>
                    　
                    <a href="#17/35.2475844233464/136.972192456311">春日井市</a>
                    　<a href="#17/34.8268542196479/137.375805189825">豊川市</a>
                    　<a href="#17/35.1770423165112/136.741226579637">津島市</a>
                    　<a href="#17/35.0824025701822/137.156308811042">豊田市</a>
                    　<a href="#17/34.9586226849259/137.080342321001">安城市</a>
                    　<a href="#17/35.1319917180338/137.039453547074">日進市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>三重県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.9651236717905/136.624511503246">四日市市</a>
                    　<a href="#17/33.8886054430896/136.10022466187">熊野市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>京都府　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.011764001781/135.76800218942">京都市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>大阪府　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.6937668942253/135.502206656759">大阪市</a>　
                    <a href="#17/34.5735806367771/135.483039615185">堺市</a>　
                    <a href="#17/34.7812526999677/135.469745196524">豊中市</a>　
                    <a href="#17/34.8217524552345/135.428453084308">池田市</a>　
                    <a href="#17/34.8461725583813/135.617394223918">高槻市</a>　
                    <a href="#17/34.4580345926363/135.564106619128">
                      河内長野市
                    </a>
                    　<a href="#17/34.4831599410326/135.423304156671">和泉市</a>
                    　<a href="#17/34.5782796199578/135.629235204209">柏原市</a>
                    　<a href="#17/34.7773425000904/135.561802626969">摂津市</a>
                    　<a href="#17/34.4871735994675/135.401406076107">忠岡町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>兵庫県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.8156140359497/134.685533828322">姫路市</a>　
                    <a href="#17/34.7569136834383/134.841270950145">加古川市</a>
                    　<a href="#17/34.7969052702387/134.990212434187">三木市</a>
                    　<a href="#17/35.3398379098133/134.852812016289">朝来市</a>
                    　
                    <a href="#17/34.8578988160401/134.545403719413">たつの市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>和歌山県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.2305471450603/135.170802552133">和歌山市</a>
                    　<a href="#17/33.505935/135.600078">すさみ町</a>　
                    <a href="#17/33.5940421275199/135.943950109359">太地町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>鳥取県　</nobr>
                  </div>
                  <div>
                    <a href="#17/35.4943906482311/134.222151756329">鳥取市</a>　
                    <a href="#17/35.4280583346388/133.330981434834">米子市</a>　
                    <a href="#17/35.5396243817171/133.231631174255">境港市</a>　
                    <a href="#17/35.4401650673508/133.380750996164">日吉津村</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>岡山県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.7451734754417/134.188800743132">備前市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>広島県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.385237573848/132.455384101662">広島市</a>　
                    <a href="#17/34.2485679001191/132.56534770124">呉市</a>　
                    <a href="#17/34.3412690993352/132.905332913711">竹原市</a>　
                    <a href="#17/34.4859254783755/133.362541977113">福山市</a>　
                    <a href="#17/34.5683154172445/133.236347900357">府中市</a>　
                    <a href="#17/34.8055634098921/132.851698669074">三次市</a>　
                    <a href="#17/34.3663805527658/132.536243039657">海田町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>徳島県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.070275578192/134.554827235824">徳島市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>香川県　</nobr>
                  </div>
                  <div>
                    <a href="#17/34.3426665311032/134.046753607365">高松市</a>　
                    <a href="#17/34.3252411386423/134.172106383832">さぬき市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>愛媛県　</nobr>
                  </div>
                  <div>
                    <a href="#17/33.8391626018694/132.765643114321">松山市</a>　
                    <a href="#17/33.7910778643711/132.871770673465">東温市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>福岡県　</nobr>
                  </div>
                  <div>
                    <a href="#17/33.8834800055665/130.875216675391">北九州市</a>
                    　<a href="#17/33.5901290840751/130.401722052675">福岡市</a>
                    　
                    <a href="#17/33.0301966965723/130.446143240478">大牟田市</a>
                    　
                    <a href="#17/33.3193681799217/130.508400149781">久留米市</a>
                    　<a href="#17/33.6465981610959/130.691144466073">飯塚市</a>
                    　<a href="#17/33.8056899948603/130.540582683544">宗像市</a>
                    　
                    <a href="#17/33.3474224233445/130.754975770927">うきは市</a>
                    　<a href="#17/33.4570434366449/130.59517481638">筑前町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>佐賀県　</nobr>
                  </div>
                  <div>
                    <a href="#17/33.1947789623013/130.021380759575">武雄市</a>　
                    <a href="#17/33.2736936047143/130.217057018771">小城市</a>　
                    <a href="#17/33.2138694547944/130.116037812721">大町町</a>　
                    <a href="#17/33.2204642742277/130.157368167806">江北町</a>　
                    <a href="#17/33.1807744817686/130.143535408261">白石町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>長崎県　</nobr>
                  </div>
                  <div>
                    <a href="#17/33.1799793284339/129.715113209137">佐世保市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>熊本県　</nobr>
                  </div>
                  <div>
                    <a href="#17/32.8034559130049/130.708205072665">熊本市</a>　
                    <a href="#17/32.9867362085136/130.433045958043">荒尾市</a>　
                    <a href="#17/32.9352189530854/130.562767194857">玉名市</a>　
                    <a href="#17/32.7916035269284/130.816384680467">益城町</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>大分県　</nobr>
                  </div>
                  <div>
                    <a href="#17/33.3212685338758/130.941304877206">日田市</a>　
                    <a href="#17/33.1261220140652/131.80506524412">臼杵市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>宮崎県　</nobr>
                  </div>
                  <div>
                    <a href="#17/32.5821872711459/131.665048206552">延岡市</a>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div>
                    <nobr>沖縄県　</nobr>
                  </div>
                  <div>
                    <a href="#17/26.2123696910243/127.679161577532">那覇市</a>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="3" onClick={manageOpenItems}>
                使い方・凡例
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <div className="d-flex flex-wrap justify-content-center">
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual01.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">3Dの表示変更</Card.Title>
                      <Card.Text>
                        3D都市モデルの表示変更は、画面左側のスライダーメニューから行ないます。
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual02.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">建物の表示</Card.Title>
                      <Card.Text>
                        {" "}
                        [3D都市モデルの建物]ラジオボタンで、建物の非表示/2D表示/3D表示を変更します。
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual03.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">地形の表示</Card.Title>
                      <Card.Text>
                        {" "}
                        [3D都市モデルの地形]チェックボックスで、地形の表示/非表示を変更します。
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual07.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">3Dの向き</Card.Title>
                      <Card.Text>
                        {" "}
                        マウスの右ボタンをドラッグすると、地図が傾き、3Dの向きが変わります。
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual04.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">公共・文教建物</Card.Title>
                      <Card.Text>
                        ピンク色の建物は、役場・学校・病院等の公共・文教建物です。（用途情報がある建物に限ります）
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual05.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">宿泊施設建物</Card.Title>
                      <Card.Text>
                        水色の建物は、ホテル等の宿泊施設建物です。（用途情報がある建物に限ります）
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual06.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">商業施設建物</Card.Title>
                      <Card.Text>
                        黄色の建物は、商業施設の建物です。（用途情報がある建物に限ります）
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual09.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">他の建物</Card.Title>
                      <Card.Text>
                        グレーの建物は、他の建物もしくは用途情報がない建物です。
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card
                    style={{ width: "14rem", margin: "10px", padding: "5px" }}
                  >
                    <Card.Img
                      variant="top"
                      src="mapple01/mojmap/3dmanual/3dmanual08.png"
                      alt=""
                    />
                    <Card.Body>
                      <Card.Title as="h5">3D地形の注意点</Card.Title>
                      <Card.Text>
                        3D都市モデル（PLATEAU）の地形の整備境界際では、地形が大きな段差のように表示されます。
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="4" onClick={manageOpenItems}>
                注意事項
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="4">
              <Card.Body>
                <p>
                  ・地図の移動等の操作が正常に動作しない場合は、ページの再読み込みをお願いいたします。
                </p>
                <p>
                  ・3D都市モデル（PLATEAU）の建築物の有無・属性・詳細度は、データの整備状況と変換仕様によります。
                </p>
                <p>
                  ・3D都市モデル（PLATEAU）の地形の整備境界際では、地形が大きな段差のように表示されます。
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        2026 Copyright MAPPLE, Inc. <br />
        <Button variant="primary" className="w-100" onClick={handleClose}>
          MAPPLE法務局地図ビューアに戻る
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PlateauModal;
